
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'IPColumn',
  props: {
    sip: {
      type: String,
      default: ''
    },
    cip: {
      type: String,
      default: ''
    }
  }
})
